import { useQuery } from 'react-query';

import finesService from '../../services/api/fines/fines.api.service';
import { useGetOnboardStatus } from '../onboard-status/onboard-status.queries';

export const useIndividualUnpaidFines = (
  filter: string[],
  active = false,
  noticeNumber: string,
) => {
  return useQuery(
    ['getIndividualUnpaidFines', filter, noticeNumber],
    () => finesService.fetchIndividualUnpaidFines(filter, noticeNumber),
    {
      enabled: active,
    },
  );
};

export const useBusinessUnpaidFines = (filter: string[], active = false) => {
  const getOnboardStatusQuery = useGetOnboardStatus();
  return useQuery(
    ['getBusinessUnpaidFines', filter],
    () => finesService.fetchBusinessUnpaidFines(filter),
    {
      enabled: active && getOnboardStatusQuery?.data?.fleet,
    },
  );
};

export const useIndividualPaidFines = (filter: string[], active = false, noticeNumber: string) => {
  return useQuery(
    ['getIndividualPaidFines', filter, noticeNumber],
    () => finesService.fetchIndividualPaidFines(filter, noticeNumber),
    { enabled: active },
  );
};

export const useIndividualDiscount = (filter: string[], active = false) => {
  return useQuery(
    ['getIndividualDiscount', filter],
    () => finesService.fetchIndividualDiscount(filter),
    { enabled: active },
  );
};

export const useBusinessPaidFines = (filter: string[], active = false) => {
  return useQuery(
    ['getBusinessPaidFines', filter],
    () => finesService.fetchBusinessPaidFines(filter),
    { enabled: active },
  );
};
